import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    getCurrUrlParamValue,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {AutoCompleteView, Label} from "../../common/fusion-ui";
import {CssVariant, Messages} from "../../common/fusion-ui/config/FusionConfig";
import {FormPageRoot} from "../components";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const Group__AddEditMembersFormPage = React.memo(({
                                                      updateOnly,
                                                      open,
                                                      onHide,
                                                      recordId,
                                                      showAs = ShowViewType.PAGE,
                                                      onSuccess,
                                                  }) => {
    const TAG = "Group__AddEditMembersFormPage";

    const moduleName = AdminModules.Groups;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const Fields = {
        updateRecordId: 'updateRecordId',
        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Group__AddEditMembersFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId, 'updateOnly:', isUpdateMode());
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && (isUpdateMode())) {
                fetchEditModeData(recordId, false);
            }
        }
    }, [recordId, showAs, updateOnly]);

    return (<>
            <FormPageRoot
                tag={TAG}
                moduleName={AdminModules.GroupsMembers}
                updateOnly={isUpdateMode()}
                isDataLoading={getField(Fields.isDataLoading)}
                isDataFound={getField(Fields.isDataFound)}
                dataLoadingMsg={getField(Fields.dataLoadingMsg)}
                editPageTitle={"Manage Member Group"}
                backUrl={AdminModuleRouteUrls[moduleName]}
                open={open}
                onHide={() => {
                    if (onHide) onHide();
                    clearPanelData(true);
                }}
                showAs={showAs}
                md={12}
                panelMsg={getField(Fields.panelMsg)}
                panelMsgColor={getField(Fields.panelMsgColor)}
                isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
                isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                onSubmit={handleSubmit}
                onPageRefresh={() => fetchEditModeData(getField(Fields.updateRecordId), false)}
            >
                <div className={''}>
                    {/*companyName*/}
                    <Label className={`m-0 p-0 px-2x text-theme-resp`}>
                        <span className={'fw-bold m-0 p-0'} style={{width: '100px'}}>{mf.companyName.titleAlt}: </span>
                        <span className={''}>{getFormField(mf.companyName)}</span>
                    </Label>

                    {/*name*/}
                    <Label className={`m-0 p-0 px-2x mt-1 text-theme-resp`}>
                        <span className={'fw-bold m-0 p-0'} style={{minWidth: '100px'}}>{mf.name.title}: </span>
                        <span className={''}>{getFormField(mf.name)}</span>
                    </Label>

                    {/*member-list*/}
                    <div className={'mt-3'}>
                        <AutoCompleteView
                            tagStyle={{borderColor: theme.text}}
                            msgLabelColor={theme.text70}
                            nameColor={theme.text}
                            searchColor={theme.text}
                            dropdownItemHoverBg={theme.primaryBlue20}
                            dropdownItemHoverColor={theme.primaryBlueDark}
                            dropdownItemSelectedBg={theme.primaryBlue20}
                            dropdownItemSelectedColor={theme.primaryBlue}
                            tagBoxBorderColor={theme.text20}
                            labelColor={theme.text40}
                            countColor={theme.text40}
                            tagBg={theme.text10}
                            // dropdownHeight={'45vh'}
                            tagBoxMinHeight={'30vh'}
                            tagBoxHeight={'50vh'}
                            searchPlaceholder={'Search for members...'}
                            label={"Members"}
                            synced={true}
                            required={true}
                            // showRefresh={true}

                            options={getFormField(mf.members)}
                            itemNameKey={'name'}
                            // itemImageKey={'image'}
                            itemHoverAltNameKey={'email'}

                            removeColor={theme.text}
                            // showLoading={isFieldTrue(Fields.isMemberListLoading)}
                            // refreshLoading={isFieldTrue(Fields.isMemberListLoading)}
                            // disableRefresh={isFieldTrue(Fields.isMemberListLoading)}

                            onSelected={(updatedList, selectedList) => {
                                updateFormField(mf.memberIds, selectedList);
                                // log('recList.userList.onUsersSelected.updatedList:', updatedList);
                                // log('AutoCompleteView.userList.onUsersSelected.selectedList:', selectedList);
                            }}
                            // onRefresh={() => fetchMemberList(false)}
                            dropdownStyle={theme.autoCompleteDropdownStyles}
                        />
                    </div>
                </div>
            </FormPageRoot>
        </>
    )

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__groupMembers_editPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData(true);
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__groupMembers_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // const memberIdsOrg = dropArrEmptyValues((getJsonValue(fetchedFormData, mf.memberIds.column) + '').split(',')).map(id => parseInteger(id, -1)).filter(id => id != -1);
                                // let members = getJsonValue(fetchedFormData, mf.members.column);
                                // log(fun, 'fetchedData.memberIdsOrg:', memberIdsOrg);
                                // if (checkNullArr(members)) {
                                //     members = getJsonValue(fetchedFormData, mf.members.column).map((item) => {
                                //         if (memberIdsOrg.includes(parseInteger(getJsonValue(item, 'id')))) {
                                //             return {...item, selected: true}
                                //         }
                                //         return item;
                                //     })
                                // }
                                // // log(fun, 'fetchedData.members:', members);
                                // fetchedFormData[mf.members.column] = members;

                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [mf.memberIds];

        let verified = false;
        let colField = {};
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (deepObjectComparison(loopField, mf.memberIds) && !checkNullArr(getFormField(mf.memberIds))) {
                toast(`Please select some members first!`, CssVariant.warning);
                return false;
            } else if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData(refetchAddFormData = false) {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
        if (isBoolTrue(refetchAddFormData) && showAs != ShowViewType.PAGE && !isUpdateMode()) {
            updateField(Fields.dataLoadingMsg, '');
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default Group__AddEditMembersFormPage;
